var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_35544",
    "data-name": "Group 35544",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#fc3",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35544-2",
    "data-name": "Group 35544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5524",
    "data-name": "Rectangle 5524",
    d: "M1.333,0H12a1.334,1.334,0,0,1,1.334,1.334V12A1.333,1.333,0,0,1,12,13.333H1.333A1.333,1.333,0,0,1,0,12V1.333A1.333,1.333,0,0,1,1.333,0Z",
    transform: "translate(5.555 5.555)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39503",
    "data-name": "Path 39503",
    d: "M14,5.111V2.889A2.222,2.222,0,0,0,11.779.666H2.889A2.222,2.222,0,0,0,.667,2.889v8.888A2.222,2.222,0,0,0,2.889,14H5.112",
    transform: "translate(0.445 0.444)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.573997a0f1da76617fbdc3883a477477.svg";
export { ForwardRef as ReactComponent };